// =============================================================================
// SLOT ICONS — source unique des icônes MUI par type de slot.
// Utilisées dans le dock (ToolsDock) et au centre du rond (SlotFlowNode).
// Revue PO : le petit personnage (PersonOutline) est l'icône du slot
// « Character » ET des custom models (blocs, cartes) ; la silhouette de lapin
// (RabbitLoraIcon) est l'icône de la feature « Rabbits » (menu latéral,
// CanvasContextMenu, dock).
// =============================================================================

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import DiamondIcon from '@mui/icons-material/Diamond';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LightModeIcon from '@mui/icons-material/LightMode';
import BrushIcon from '@mui/icons-material/Brush';
import CameraIcon from '@mui/icons-material/Camera';
import type { SlotType } from '../types';

// Toutes les icônes MUI partagent le même type de composant (SvgIcon).
export const SLOT_ICONS: Record<SlotType, typeof PersonOutlineIcon> = {
  character: PersonOutlineIcon,
  outfit: CheckroomIcon,
  accessory: DiamondIcon,
  pose: AccessibilityIcon,
  emotion: EmojiEmotionsIcon,
  location: LocationOnIcon,
  light: LightModeIcon,
  style: BrushIcon,
  photography: CameraIcon,
};
